import React, { useEffect } from "react";
import ProduitDetailHeader from "../components/produitDetail/ProduitDetailHeader";
import ProduitDetailMain from "../components/produitDetail/ProduitDetailMain";
import ProduitDetailFooter from "../components/produitDetail/ProduitDetailFooter";
import { useParams } from "react-router-dom";
import HomeFooter from "@/components/homePage/HomeFooter";
import HomeHeader2 from "@/components/homePage/HomeHeader2";
import HomeFooter2 from "@/components/homePage/HomeFooter2";

function ProduitDetail({ panierchg, paniernbr, acces }) {
  const params = useParams();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [params.id]);
  return (
    <>
      <HomeHeader2 acces={acces} paniernbr={paniernbr} />
      <ProduitDetailMain panierchg={panierchg} />
      {/* <ProduitDetailFooter /> */}
      <HomeFooter2 />
    </>
  );
}

export default ProduitDetail;
